
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin, BAIconsMixin, StringsMixin, HelpInfoMixin } from '@/mixins';
import { AthleteProfileModel } from '@/models';

@Component
export default class AthleteEducationCard extends Mixins(VuetifyMixin, StringsMixin, BAIconsMixin, HelpInfoMixin) {
    @Prop() athleteProfile: AthleteProfileModel;
}
